import { Module } from 'vuex';
import { RootState } from 'frontend/types';
import { MarketingLandingPage } from 'frontend/types/landing/marketing';

export interface MarketingLandingPageState {
  marketingLandingPage: MarketingLandingPage;
}

const marketingLandingPage: Module<MarketingLandingPageState, RootState> = {
  namespaced: true,
  state: {
    marketingLandingPage: {} as MarketingLandingPage,
  },
  mutations: {
    setValue(state: MarketingLandingPageState, value: MarketingLandingPage): void {
      state.marketingLandingPage = value;
    },
  },
};

export default marketingLandingPage;
